import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import dayjs from "dayjs";
import SpendingForm from "./SpendingForm";
import useSpendingCreate from "../hooks/useSpendingCreate";

export default function SpendingModal({ open, onClose, onCompleted, queryOption }) {
  const formRef = useRef(null);

  // 只在這個 component 的生命週期內記住上次選的日期，讓連續記帳時沿用。
  // 存在 React state（非 localStorage），所以 component unmount 或網頁重開都會回到今天。
  const [lastDate, setLastDate] = useState(() => dayjs());

  const [addSpending, { loading: mutationLoading }] = useSpendingCreate(queryOption, () => {
    formRef.current.resetFields();
    onClose();

    if (onCompleted) {
      onCompleted();
    }
  });

  return (
    <Modal title="記錄新消費" open={open} centered footer={null} onCancel={() => onClose()}>
      <SpendingForm
        ref={formRef}
        uploading={mutationLoading}
        initialValues={{ date: lastDate }}
        onSubmit={(value) => {
          // 記住這次選的日期，同一 session 內下次開啟 modal 時沿用。
          setLastDate(value.date);
          addSpending({
            variables: {
              ...value,
              amount: Number(value.amount),
            },
          });
        }}
      />
    </Modal>
  );
}

SpendingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
  queryOption: PropTypes.shape({
    query: PropTypes.object,
  }).isRequired,
};

SpendingModal.defaultProps = {
  onCompleted: null,
};
